import { ApiError } from './api/http'

/**
 * Foutcodes van de server in Sarah's toon. De server stuurt `{ message, code? }`; voor deze
 * codes wint de tekst hieronder, zodat dezelfde situatie overal hetzelfde klinkt, ongeacht
 * wat de server als `message` meegeeft. Onbekende codes tonen gewoon de `message`.
 */
const CODE_TEXT: Record<string, string> = {
  total_mismatch: 'Er is net iets veranderd aan een prijs of de voorraad. Kijk het totaal nog even na, dan kun je meteen verder.',
  change_window_closed: 'Deze levering ligt al klaar om ingepakt te worden. Wijzigen kan weer bij de volgende.',
  undo_expired: 'Terugdraaien kan niet meer. Pas het gewoon even opnieuw aan.',
  version_conflict: 'Iemand anders heeft dit net aangepast. Ververs de pagina om de nieuwste versie te zien.',
  idempotency_conflict: 'Deze aanvraag is al verstuurd met andere gegevens. Ververs de pagina en probeer het opnieuw.',
  email_unverified: 'Bevestig eerst je e-mailadres via de link in je mail. Niets ontvangen? Kijk ook even in je spam.',
  photo_consent_required: 'Geef eerst toestemming om je foto’s te bewaren. Het vinkje staat onder je foto.',
  link_expired: 'Deze link is verlopen of al gebruikt.',
  reauth_required: 'Log voor de zekerheid nog één keer opnieuw in, en probeer het daarna nog eens.',
  already_paid: 'Deze bestelling is al betaald. Je krijgt de bevestiging per mail.',
  slot_taken: 'Dit tijdstip is net bezet geraakt. Kies een andere tijd.',
  request_mismatch: 'Dit verzoek is al verwerkt met andere gegevens. Ververs de pagina en probeer het opnieuw.',
  booking_blocked: 'Online een afspraak maken lukt nu niet. Bel of app ons even, dan plannen we samen een moment.',
  appointment_closed: 'Deze afspraak is intussen al afgerond of geannuleerd.',
  voucher_unknown: 'Deze code ken ik niet. Kijk hem nog even na; hij staat op de bon.',
  voucher_expired: 'Deze cadeaubon is verlopen.',
  voucher_empty: 'Deze cadeaubon is al helemaal gebruikt.',
  voucher_blocked: 'Deze cadeaubon is geblokkeerd. Neem even contact met ons op.',
  open_balance: 'Je hebt nog tegoed of een lopende kuur. Neem contact op met de salon, dan regelen we dat eerst samen.',
  payment_changed: 'De betaling kwam net binnen. De bestelling is opnieuw geladen: annuleren betaalt nu ook terug.',
  mollie_uncertain: 'Mollie gaf geen antwoord. Probeer het over een minuut opnieuw met dezelfde knop; er wordt niet dubbel terugbetaald.',
  voucher_treatments_only: 'Deze cadeaubon is voor behandelingen in de salon.',
}

const STATUS_TEXT: Record<number, string> = {
  429: 'Even rustig aan: je hebt dit een paar keer snel achter elkaar geprobeerd. Wacht een minuutje en probeer het dan opnieuw.',
  419: 'Je sessie is verlopen. Ververs de pagina en probeer het opnieuw.',
}

/** De leesbare melding van een fout, of `undefined` als er geen is (dan toont een toast alleen de titel). */
/** Bij een serverfout (5xx) nooit de servertekst: die kan technisch zijn of interne details bevatten. */
export const SERVER_ERROR_TEXT = 'Er ging iets mis bij ons. Probeer het zo nog eens.'

export const errorMessage = (err: unknown): string | undefined => {
  if (err instanceof ApiError) {
    const known = (err.code && CODE_TEXT[err.code]) || (err.status !== undefined ? STATUS_TEXT[err.status] : undefined)
    if (known) return known
    if (err.status !== undefined && err.status >= 500) return SERVER_ERROR_TEXT
  }
  return err instanceof Error && err.message ? err.message : undefined
}
